import { DesktopOnly, TabletOrNarrowerOnly } from '@upright/ui/common/generic/layout/breakpoint-utils';
import { useImpactDetailsRevenue } from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes/single-impact/common/use-impact-details-revenue';
import { useComparisonBoxes } from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes/single-impact/comparisons';
import { FigureBoxesMobile } from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes/single-impact/figure-boxes-mobile';
import { FigureBoxesDesktop } from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes/single-impact/figures-boxed-desktop';

export interface BoxesProps {
  comparisonBoxCount: number;
  valueChainBoxCount: number;
  monetaryBoxCount: number;
  totalBoxCount: number;
}

export function FigureBoxes() {
  const { isFallback: isFallBackRevenue } = useImpactDetailsRevenue();
  const comparisonBoxes = useComparisonBoxes();
  const comparisonBoxCount = comparisonBoxes.length;
  const monetaryBoxCount = isFallBackRevenue ? 1 : 2;
  const valueChainBoxCount = 1;
  const totalBoxCount = comparisonBoxCount + monetaryBoxCount + valueChainBoxCount;
  const props: BoxesProps = { comparisonBoxCount, valueChainBoxCount, monetaryBoxCount, totalBoxCount };
  return (
    <>
      <TabletOrNarrowerOnly>
        <FigureBoxesMobile {...props} />
      </TabletOrNarrowerOnly>
      <DesktopOnly>
        <FigureBoxesDesktop {...props} />
      </DesktopOnly>
    </>
  );
}
